import { Config } from '../config';
import { UserService } from './User';

export const InternalTransferService = {
  /**
 * [HISTORY]
 * @param {object} data
 * @param {string} data.beginDate
 * @param {string} data.endDate
 * @param {string} data.status
 */
  History(data) {
    const requestOptions = {
      method: 'POST',
      headers: Config.utilities.authorizedHeader(),
      body: JSON.stringify(data),
    };

    return InternalTransferService.Common.Fetch(Config.service.internalTransfer.history, requestOptions);
  },
  /**
* [DETAIL]
* @param {object} transactionId
*/
  Detail(data) {
    const requestOptions = {
      method: 'POST',
      headers: Config.utilities.authorizedHeader(),
      body: JSON.stringify(data),
    };

    return InternalTransferService.Common.Fetch(Config.service.internalTransfer.detail, requestOptions);
  },
  SaveComment(data) {
    const requestOptions = {
      method: 'POST',
      headers: Config.utilities.authorizedHeader(),
      body: JSON.stringify(data),
    };

    return InternalTransferService.Common.Fetch(Config.service.internalTransfer.saveComment, requestOptions);
  },
  /**
    * [CONFIRM]
    * @param {string} transactionId
    * @param {string} type
    */
  Confirm(data) {
    const requestOptions = {
      method: 'POST',
      headers: Config.utilities.authorizedHeader(),
      body: JSON.stringify(data),
    };

    return InternalTransferService.Common.Fetch(Config.service.actions.confirm, requestOptions);
  },
  /**
    * [CANCEL]
    * @param {string} transactionId
    * @param {string} type
    */
  Cancel(data) {
    const requestOptions = {
      method: 'POST',
      headers: Config.utilities.authorizedHeader(),
      body: JSON.stringify(data),
    };

    return InternalTransferService.Common.Fetch(Config.service.actions.cancel, requestOptions);
  },

  /**
 * [COMMON]
 * @function Fetch
 */
  Common: {
    Fetch(url, requestOptions) {
      return fetch(url, requestOptions)
        .then(response => {
          if (response.ok) {
            return response.json();
          }
          if (response.status === 401) {
            UserService.Logout();
            window.location.reload();
          } else {
            throw new Error();
          }
          return false;
        })
        .then(json => json)
        .catch(() => false);
    },
  },
};
